import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Typography } from '@material-ui/core';
import ExtensionIcon from '@material-ui/icons/Extension';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: theme.spacing(6),
    textAlign: 'center',
  },
  logoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(4),
  },
  logoText: {
    fontWeight: 700,
    letterSpacing: '0.05em',
  },
  tagline: {
    maxWidth: 560,
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  featureGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(3),
    maxWidth: 700,
    marginBottom: theme.spacing(6),
  },
  featureCard: {
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    textAlign: 'left',
  },
  featureTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  cta: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    fontSize: '1rem',
  },
}));

interface Props {
  onNext: () => void;
}

const FEATURES = [
  {
    title: 'Golden Paths',
    body: 'Scaffold new services, pipelines, and teams in minutes.',
  },
  {
    title: 'Full Observability',
    body: 'Metrics, logs, and tracing — wired up out of the box.',
  },
  {
    title: 'Secure by Default',
    body: 'Workload Identity, Key Vault, and policy-as-code baked in.',
  },
];

export function WelcomeStep({ onNext }: Props) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.logoRow}>
        <ExtensionIcon fontSize="large" color="primary" />
        <Typography variant="h4" className={classes.logoText}>
          CJOT&nbsp;Platform
        </Typography>
      </Box>

      <Typography variant="h5" gutterBottom>
        Welcome to the Kyndryl Internal Developer Platform
      </Typography>

      <Typography variant="body1" className={classes.tagline}>
        This wizard will get you set up in under 5&nbsp;minutes. You'll
        acknowledge the platform docs, join or create a team, and then you're
        ready to build.
      </Typography>

      <Box className={classes.featureGrid}>
        {FEATURES.map(f => (
          <Box key={f.title} className={classes.featureCard}>
            <Typography variant="subtitle2" className={classes.featureTitle}>
              {f.title}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {f.body}
            </Typography>
          </Box>
        ))}
      </Box>

      <Button
        variant="contained"
        color="primary"
        size="large"
        className={classes.cta}
        onClick={onNext}
      >
        Get Started
      </Button>
    </Box>
  );
}
